import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { ProyectosService } from '../proyectos.service';

export interface ImagenItem {
  id: number;
  UsuarioId: string;
  url_image: string;
}

@Component({
  selector: 'app-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.css']
})
export class ImagesComponent implements OnInit {
  imagenes: ImagenItem[] = [];
  imagenSeleccionada: ImagenItem | null = null;
  isLoading = false;
  errorMessage = '';

  constructor(
    private authService: AuthService,
    private proyectosService: ProyectosService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Verificar si hay un parámetro de imagen en la URL
    this.route.queryParams.subscribe(params => {
      if (params['imagenId']) {
        const imagenId = parseInt(params['imagenId'], 10);
        this.cargarImagenEspecifica(imagenId);
      } else {
        // Si no hay imagenId, cargar todas las imágenes (comportamiento anterior)
        this.cargarImagenes();
      }
    });
  }

  cargarImagenEspecifica(imagenId: number) {
    const userId = this.authService.getUserId();
    
    if (!userId) {
      this.errorMessage = 'Debes iniciar sesión para ver tus imágenes';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.proyectosService.getImagenes(userId).subscribe({
      next: (response) => {
        this.imagenes = response.imagenes || [];
        const imagen = this.imagenes.find(img => img.id === imagenId);
        if (imagen) {
          this.imagenSeleccionada = imagen;
        } else {
          this.errorMessage = 'Imagen no encontrada';
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error cargando imagen:', error);
        this.errorMessage = 'Error al cargar la imagen. Por favor intenta nuevamente.';
        this.isLoading = false;
      }
    });
  }

  cargarImagenes() {
    const userId = this.authService.getUserId();
    
    if (!userId) {
      this.errorMessage = 'Debes iniciar sesión para ver tus imágenes';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.proyectosService.getImagenes(userId).subscribe({
      next: (response) => {
        this.imagenes = response.imagenes || [];
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error cargando imágenes:', error);
        this.errorMessage = 'Error al cargar las imágenes. Por favor intenta nuevamente.';
        this.isLoading = false;
      }
    });
  }

  seleccionarImagen(imagenId: number) {
    const imagen = this.imagenes.find(img => img.id === imagenId);
    if (imagen) {
      this.imagenSeleccionada = imagen;
      // Actualizar URL sin recargar la página
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { imagenId: imagenId },
        queryParamsHandling: 'merge'
      });
    }
  }

  cerrarImagen() {
    this.imagenSeleccionada = null;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {}
    });
  }

  getImageName(url: string): string {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      const fileName = pathname.split('/').pop() || 'imagen';
      // Remover timestamp si existe (formato: nombre_timestamp.ext)
      return fileName.replace(/_\d+\./, '.');
    } catch {
      return 'imagen';
    }
  }

  async descargarImagen(url: string, event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevenir que se active el click en el contenedor
    }
    
    try {
      // Obtener el nombre del archivo
      const fileName = this.getImageName(url);
      
      // Obtener la imagen como blob usando fetch
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Error al obtener la imagen');
      }
      
      const blob = await response.blob();
      
      // Crear un objeto URL temporal para el blob
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Crear un enlace temporal para descargar
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      link.style.display = 'none';
      
      // Agregar al DOM, hacer click y remover
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Liberar el objeto URL después de un breve delay
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      console.error('Error descargando imagen:', error);
      // Fallback: intentar descarga directa
      try {
        const link = document.createElement('a');
        link.href = url;
        link.download = this.getImageName(url);
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (fallbackError) {
        console.error('Error en fallback de descarga:', fallbackError);
        // Último recurso: abrir en nueva pestaña
        window.open(url, '_blank');
      }
    }
  }
}
